import { createI18n } from 'vue-i18n'
import { processLangFiles } from './loadLang'

// 固定字面量 glob
const zhModules = import.meta.glob('./cn/**/*.json', { eager: true })
const enModules = import.meta.glob('./en/**/*.json', { eager: true })

const zhLocale = processLangFiles(zhModules)
const enLocale = processLangFiles(enModules)

const messages = {
  cn: { ...zhLocale },
  en: { ...enLocale }
}

export function getLanguage() {
  return localStorage.getItem('language') || 'cn'
}

const i18n = createI18n({
  legacy: false,
  locale: getLanguage(),
  messages
})

export default i18n
